var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cadfm-container-horizontal"},[_c('Main',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.params.view == 'Main'),expression:"$route.params.view == 'Main'"}],attrs:{"lang":_vm.lang.Settings.Main}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-080e744c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settings/Settings.vue
// module id = null
// module chunks = 